import React, { useEffect } from "react";
import me from "../../assets/2.JPG";
import "./About.css";

import AOS from "aos";
import "aos/dist/aos.css";

const About = () => {
  useEffect(() => {
    AOS.init({
      duration: 2000,
    });
  }, []);
  return (
    <section className="About" id="about">
      <h2 data-aos="fade-in">About me</h2>
      <div className="About-container">
        <div className="About-img" data-aos="slide-up">
          <img src={me} alt="MyImg" />
        </div>
        <div className="About-text" data-aos="zoom-in">
          <p>
            My name is Emmanuel, I am a passionate programmer with strong
            foundation on JavaScript and Python. I apply my programming
            knowledge on Web development and Data science I care about writing
            clean code, I love to carry out research, analyzing data and
            building machine learning models with various technical tools to
            solve problem and make effective decision. I genuinely Love to
            learn.
          </p>
          <br />
          <p>
            Through various data analysis technique and tools I can derive and
            get pattern from complex data. I have a Bachelor degree in Economics
            and have attended various Bootcamps on machine learning and web
            development.
          </p>
          <p>
            I have built frontend and full stack application using popular
            javascript framework like ReactJS, NextJS and NodeJS. With python
            using Django i can build backend web applications
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
